function dataQa(props) {
  const {
    dataQaType,
    dataQaData
  } = props;
  return {
    'data-qa-type': dataQaType,
    'data-qa-data': typeof dataQaData === 'object' ? JSON.stringify(dataQaData) : dataQaData
  };
}
export default dataQa;